export default [
  {
    itemType: 'group',
    colCount: 1,
    items: [
      {
        dataField: 'tabela',
        label: { text: 'Descrição' },
        validationRules: [{
          type: 'required',
          message: 'Descrição é obrigatório'
        }]
      },
      {
        dataField: 'fator_multiplicacao',
        label: { text: 'Fator Multiplicação' },
        editorType: 'dxNumberBox',
        editorOptions: {
          format: '#0.##'
        }
      },
      {
        dataField: 'ativa',
        label: { text: 'Ativa' },
        editorType: 'dxSelectBox',
        editorOptions: {
          items: [
            { value: 'S', label: 'Sim' },
            { value: 'N', label: 'Não' }
          ],
          displayExpr: 'label',
          valueExpr: 'value'
        }
      }
    ]
  }
]
